import { render, staticRenderFns } from "./MegaMenuColumn.vue?vue&type=template&id=1f92d727"
import script from "./MegaMenuColumn.vue?vue&type=script&lang=js"
export * from "./MegaMenuColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports